import { gql } from "@apollo/client";

export const UPDATE_PRODUCT_COLLECTIONS = gql`
  mutation UpdateProductCollections($id: Int!, $collections: [CollectionWhereUniqueInput!]!) {
    updateExistingAdvancedProduct2(
      where: { id: $id }
      collections: $collections
    ) {
      id
      collection {
        id
        collection_profiles {
          name
          language
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT_TAGS = gql`
  mutation UpdateProductTags($id: Int!, $tags: [TagWhereUniqueInput!]!) {
    updateExistingAdvancedProduct2(
      where: { id: $id }
      tags: $tags
    ) {
      id
      tags {
        id
        tag_profiles {
          name
          language
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT_CATEGORIES = gql`
  mutation UpdateProductCategories($id: Int!, $categories: [CategoryWhereUniqueInput!]!) {
    updateExistingAdvancedProduct2(
      where: { id: $id }
      categories: $categories
    ) {
      id
      categories {
        id
        category_profiles {
          name
          language
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT_IMAGES = gql`
  mutation UpdateProductImages($id: Int!, $images: [String!]!) {
    updateExistingAdvancedProduct2(
      where: { id: $id }
      images: $images
    ) {
      id
      advanced_product {
        images {
          id
          src
          src_thumbnail
          src_md
          display_order
        }
      }
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation CREATE_ADVANCED_PRODUCT(
    $advanced_product_profiles: [AdvancedProductProfileCustomInput!]!,
    $images: [String],
    $product_details: ProductDetailCreateInput,
    $visible: Boolean!,
    $featured: Boolean!,
    $manufacturer: Int!,
    $discount: DiscountUncheckedCreateInput,
    $dispatch_information: DispatchInformationUncheckedCreateInput,
    $styles: [StyleWhereUniqueInput],
    $collections: [CollectionWhereUniqueInput],
    $categories: [CategoryWhereUniqueInput],
    $tags: [TagWhereUniqueInput],
    $content_blocks: [ContentBlockWhereUniqueInput],
    $additional_notes: String,
    $advanced_product_skeleton: AdvancedProductSkeletonInput!,
    $advanced_product_fabric_category_prices: [AdvancedProductCategoryPriceInput!],
    $dimensions: DimensionCreateInput,
    $additional_component_groups: [AdditionalComponentGroupCustomInput],
    $sku: String,
    $ean_code: BigInt,
    $minimum_order_quantity: Int,
    $base_prices: [PriceForPriceListInput],
    $shipping_methods: [ShippingMethodWhereUniqueInput],
    $country_of_origin: String,
    $SVP_boost: Int,
    $fabricCombinations: [FabricCombinationCustomCreateInput]
  ) {
    createNewAdvancedProduct(
      advanced_product_profiles: $advanced_product_profiles
      images: $images
      product_details: $product_details
      visible: $visible
      featured: $featured
      manufacturer: $manufacturer
      discount: $discount
      dispatch_information: $dispatch_information
      styles: $styles
      collections: $collections
      categories: $categories
      tags: $tags
      content_blocks: $content_blocks
      advanced_product_skeleton: $advanced_product_skeleton
      additional_notes: $additional_notes
      dimensions: $dimensions
      advanced_product_fabric_category_prices: $advanced_product_fabric_category_prices
      additional_component_groups: $additional_component_groups
      sku: $sku
      ean_code: $ean_code
      minimum_order_quantity: $minimum_order_quantity
      base_prices: $base_prices
      shipping_methods: $shipping_methods
      country_of_origin: $country_of_origin
      SVP_boost: $SVP_boost
      fabricCombinations: $fabricCombinations
    ) {
      id
      __typename
    }
  }
`;
